export default __webpack_public_path__ + "static/media/google-play.53e265b8.svg";